/**
 * Global logger: in production, silence verbose console methods so tokens,
 * passwords, and other sensitive data are not exposed in the browser console.
 */
export const configureLogger = () => {
  if (process.env.NODE_ENV !== 'production') {
    return;
  }

  if (typeof window !== 'undefined') {
    window._originalConsole = {
      log: console.log,
      debug: console.debug,
      info: console.info,
      warn: console.warn,
      error: console.error,
    };
  }

  console.log = () => {};
  console.debug = () => {};
  console.info = () => {};
};
